(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vstories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('story-video-list')) {

    customElements.define('story-video-list', class extends HTMLElement {

      connectedCallback() {

        const previews = this.querySelectorAll('.story-videos__preview-video');
        const playPreview = (video) => {
          if (!video.paused) return;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.autoplay = true;
          video.loop = true;
          const attempt = video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        };

        previews.forEach((video) => {
          const circle = video.closest('.story-videos__circle');
          video.addEventListener('playing', () => circle?.classList.add('is-playing'));
          video.addEventListener('pause', () => circle?.classList.remove('is-playing'));
          video.addEventListener('canplay', () => playPreview(video));
          video.addEventListener('loadeddata', () => playPreview(video));
          playPreview(video);
        });

        this._resumePreviews = () => {
          if (document.hidden) return;
          previews.forEach(playPreview);
        };

        window.addEventListener('pageshow', this._resumePreviews);
        document.addEventListener('pointerdown', this._resumePreviews, { passive: true });
        document.addEventListener('touchstart', this._resumePreviews, { passive: true });
        document.addEventListener('visibilitychange', this._resumePreviews);

        if ('IntersectionObserver' in window) {
          this._previewObserver = new IntersectionObserver((entries) => {
            entries.forEach(({ target, isIntersecting }) => {
              if (isIntersecting) playPreview(target);
              else target.pause();
            });
          }, { threshold: 0.01 });
          previews.forEach((video) => this._previewObserver.observe(video));
        }

        this.querySelectorAll('[data-story-open]').forEach((trigger) => {

          trigger.addEventListener('click', () => {

            const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.storyOpen)}`);

            if (!dialog) return;

            dialog.showModal();

            const video = dialog.querySelector('video');

            if (video) video.play();

          });

        });



        this.querySelectorAll('.story-videos__dialog').forEach((dialog) => {

          const closeDialog = () => {

            const video = dialog.querySelector('video');

            if (video) {

              video.pause();

              video.currentTime = 0;

            }

            dialog.close();

          };



          dialog.querySelector('[data-story-close]')?.addEventListener('click', closeDialog);

          dialog.addEventListener('click', (event) => {

            if (event.target === dialog) closeDialog();

          });

          dialog.addEventListener('cancel', (event) => {

            event.preventDefault();

            closeDialog();

          });

        });

      }

      disconnectedCallback() {
        this._previewObserver?.disconnect();
        window.removeEventListener('pageshow', this._resumePreviews);
        document.removeEventListener('pointerdown', this._resumePreviews);
        document.removeEventListener('touchstart', this._resumePreviews);
        document.removeEventListener('visibilitychange', this._resumePreviews);
      }

    });

  }
  } catch(e) { console.error(e); }
})();

})();
